import { get, post, json, JsonFetchResponse } from './apiClient';

export interface LoginResponse {
  token?: string;
  role?: string | null;
  user?: any;
}

export async function adminLogin(email: string, password: string, otpProof?: string) {
  const body: Record<string, string> = { email, password };
  if (otpProof) body.otpProof = otpProof;
  const res = await post<LoginResponse>('/api/admin/login', json(body));
  return (res.data || {}) as LoginResponse;
}

export async function userLogin(email: string, password: string) {
  const res = await post<LoginResponse>('/api/auth/login', json({ email, password }), { credentials: 'include' });
  return (res.data || {}) as LoginResponse;
}

export async function requestPasswordReset(email: string) {
  const res = await post<any>('/api/users/password-reset/request', json({ email }), { soft: true });
  return res;
}

export async function setPassword(token: string, password: string) {
  const res = await post<any>('/api/users/set-password', json({ token, password }), { soft: true });
  return res;
}

export async function signupAtomic(payload: any) {
  const res = await post<any>('/api/auth/signup', json(payload), { soft: true });
  return res;
}

export async function abandonIncomplete(payload: { email?: string; username?: string; sessionId?: string }) {
  const res = await post<any>('/api/auth/abandon-incomplete', json(payload), { soft: true });
  return res;
}

export async function adminSession(bearer?: string | null) {
  const res = await get<any>('/api/admin/session', { soft: true, headers: bearer ? { Authorization: `Bearer ${bearer}` } : undefined });
  return res;
}

export async function deleteAdminSession(bearer?: string | null) {
  const res = await fetch('/api/admin/session', { method: 'DELETE', headers: bearer ? { authorization: `Bearer ${bearer}` } : undefined });
  return res.ok;
}
